import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { MaintenanceService } from '../services/maintenance.service';

@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private maintenanceService: MaintenanceService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Nunca bloquear requisições para /api/status (usado para checagem de disponibilidade)
        // Verifica tanto a URL completa quanto apenas o path
        if (request.url.includes('/api/status') || request.url.endsWith('status') || request.url.includes('status?noLoader=true')) {
            return next.handle(request);
        }

        // Se já está em manutenção, bloqueia outras requisições
        if (this.maintenanceService.shouldBlockRequest(request.url)) {
            // Se já está na rota de manutenção, apenas bloqueia silenciosamente
            if (this.router.url === '/maintenance') {
                return throwError(() => new Error('Maintenance mode'));
            }
            // Se não está na rota de manutenção, redireciona
            this.router.navigate(['/maintenance']);
            return throwError(() => new Error('Maintenance mode'));
        }

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {

                // Verifica se é status 503 com maintenance: true
                if (error.status === 503 && error.message === 'Maintenance mode') {
                    // Ativa o modo de manutenção
                    this.maintenanceService.activateMaintenanceMode();

                    // Redireciona para a página de manutenção se não estiver lá
                    if (this.router.url !== '/maintenance') {
                        this.router.navigate(['/maintenance']);
                    }

                    // Retorna erro silencioso (sem toast/alert)
                    // return throwError(() => new Error('Maintenance mode'));
                }

                // Para outros erros, propaga normalmente
                return throwError(() => error);
            })
        );
    }
}

